// extracted by mini-css-extract-plugin
export default {"container":"Table_container__DNwj9","columnHeader":"Table_columnHeader__ck98+","wrapper":"Table_wrapper__+uh1c"};